import React, { useEffect, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { getHistory } from './languageTermsApi'
import { rejectionMessageKeyFor } from './termsRejectionMap'
import TermHistoryPanel from './TermHistoryPanel'
import { NO_SYSTEM_VALUES } from './systemValueTerms'

/**
 * Historia 176 — RN6k (S88, S118). The ⏱ dialog of ONE key (a row's history). It fetches 2.4 for
 * `code` and hands ALL the entries of the language, unfiltered, to `TermHistoryPanel` (B5): the
 * panel filters by `termKey` itself and looks `restoredFromId` up in the whole list (T64/T65). Titled T66 (V7).
 *
 * The restore request flow (RN9 confirmation, rejection map, 409, CU11) lives in the panel, which
 * owns it through `useTermRequestFlow`: the row only reacts to its result.
 *
 * @param {{open: boolean, code: string, termKey: string, currentValue: string, readOnly: boolean, artifact: object, systemValues: object, onClose: function, onFileUnavailable: function, onRestored: function}} props
 *   `currentValue` is the key's value in `terms`, `''` when absent (inherited); `inherited` is the term painted then (RN9b).
 */
const RowHistorySlot = ({
  open = false,
  code = '',
  termKey = '',
  currentValue = '',
  inherited = '',
  readOnly = false,
  artifact = {},
  systemValues = NO_SYSTEM_VALUES,
  onClose = () => {},
  onFileUnavailable = () => {},
  onRestored = () => {}
}) => {
  const { t_ } = useSmartTranslation()
  const [entries, setEntries] = useState([])
  // CU7 E1/E2: a history that cannot be read explains itself with the rejection map.
  const [loadErrorKey, setLoadErrorKey] = useState('')

  useEffect(() => {
    if (!open) return
    let current = true
    setLoadErrorKey('')
    getHistory(code).then((all) => {
      if (current) setEntries(all)
    }).catch((error) => {
      if (current) setLoadErrorKey(rejectionMessageKeyFor(error))
    })
    return () => { current = false }
  }, [open, code, termKey])

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t_('History of "{{key}}"', { key: termKey })}</DialogTitle>
      <DialogContent>
        {loadErrorKey !== '' ? <Box role='alert'>{t_(loadErrorKey)}</Box> : null}
        {/* CU7 E1/E2: with the error shown, no "No changes recorded" and no entries (S206). */}
        {loadErrorKey === ''
          ? (
            <TermHistoryPanel
              code={code}
              termKey={termKey}
              entries={entries}
              currentValue={currentValue}
              inherited={inherited}
              readOnly={readOnly}
              artifact={artifact}
              systemValues={systemValues}
              onFileUnavailable={onFileUnavailable}
              onRestored={onRestored}
            />
            )
          : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t_('Close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RowHistorySlot
